'use client';

import React, { useState, useEffect } from 'react';
import { Carousel, CarouselApi, CarouselContent } from '../Carousel/Carousel';
export interface CarouselWithDotsProps extends React.HTMLAttributes<HTMLDivElement> {
  contentAboveDots?: React.ReactNode;
  showSneakPeek: boolean;
  setIndexFocused: (index: number) => void;
  startIndex?: number;
}
export function CarouselWithDots({
  children,
  contentAboveDots,
  showSneakPeek,
  setIndexFocused,
  startIndex = 0
}: CarouselWithDotsProps) {
  const [carouselApi, setCarouselApi] = useState<CarouselApi>();
  const [currentIndex, setCurrentIndex] = useState(startIndex);
  useEffect(() => {
    setCurrentIndex(startIndex);
  }, [startIndex]);
  useEffect(() => {
    if (!carouselApi) return;
    setIndexFocused(startIndex);
    carouselApi.on('select', () => {
      const carouselCurrentIndex = carouselApi.selectedScrollSnap();
      setCurrentIndex(carouselCurrentIndex);
      setIndexFocused(carouselCurrentIndex);
    });
  }, [carouselApi]);
  return <>
      <div className='relative flex items-center justify-center'>
        <Carousel className='w-full overflow-visible' setApi={setCarouselApi} opts={{
        startIndex: startIndex
      }} data-sentry-element="Carousel" data-sentry-source-file="CarouselWithDots.tsx">
          <CarouselContent showSneakPeek={showSneakPeek} data-sentry-element="CarouselContent" data-sentry-source-file="CarouselWithDots.tsx">
            {children}
          </CarouselContent>
        </Carousel>
      </div>
      {contentAboveDots ? contentAboveDots : null}
      {/* Dots for Carousel */}
      <div className='flex justify-center gap-3 pt-6'>
        {Array.from({
        length: carouselApi?.scrollSnapList().length ?? 1
      }).map((_, index) => <span key={`carousel-dots-${index}`} data-testid={`carousel-dot-${index}`} className={`inline-block h-3 w-3 rounded-full bg-gray-400 ${index === currentIndex ? 'bg-gray-80' : ''}`} onClick={() => carouselApi && carouselApi.scrollTo(index)} />)}
      </div>
    </>;
}